import Api from '@/services/Api'

export default {
  position (params) {
    return Api().post('betSlip/position', params)
  },
  update (params) {
    return Api().post('betSlip/update', params)
  },
  place (params) {
    return Api().post('betSlip/place', params)
  },
  fastBet (params) {
    return Api().post('betSlip/fastBet', params)
  },
  getFastBet () {
    return Api().post('betSlip/getFastBet')
  },
  fastBetOn (params) {
    return Api().post('betSlip/fastBetOn', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/BetSlipService.js